import { render, staticRenderFns } from "./Variaveis.vue?vue&type=template&id=27b3451f&"
import script from "./Variaveis.vue?vue&type=script&lang=js&"
export * from "./Variaveis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports